// Tracks which tenants the admin opens from the Platform Console, so the ones they work with
// most-recently float to the top of the tenant list — no searching needed. Stored in localStorage
// (per browser/user); unrelated to when a tenant was created.

const KEY = "crediarc_recent_tenants_v1";
const MAX = 300;

function readMap() {
  try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; }
}
function writeMap(obj) {
  try { localStorage.setItem(KEY, JSON.stringify(obj)); } catch { /* storage full/blocked — ignore */ }
}

/**
 * Record that the admin opened a tenant. Stores last-opened time + an open count.
 */
export function recordTenantVisit(tenantId) {
  if (!tenantId) return;
  const map = readMap();
  const prev = map[tenantId] || { n: 0 };
  map[tenantId] = { t: Date.now(), n: (prev.n || 0) + 1 };

  // Keep only the most-recently opened tenants so the store can't grow without bound.
  const ids = Object.keys(map);
  if (ids.length > MAX) {
    ids.sort((a, b) => (map[b].t || 0) - (map[a].t || 0));
    const keep = {};
    ids.slice(0, MAX).forEach((id) => { keep[id] = map[id]; });
    writeMap(keep);
  } else {
    writeMap(map);
  }
}

/**
 * @returns {Object<string, number>} tenantId -> last-opened timestamp (ms). Absent = never opened.
 */
export function getTenantVisits() {
  const map = readMap();
  const out = {};
  for (const id of Object.keys(map)) out[id] = map[id]?.t || 0;
  return out;
}
